(function () {
  'use strict';
  var root = document.getElementById('bnAvisoIntake');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  var form = root.querySelector('form');
  var status = root.querySelector('[data-notice-status]');
  var submit = root.querySelector('[type="submit"]');
  var challenge = root.querySelector('[data-notice-challenge]');
  var newNotice = root.querySelector('[data-new-notice]');
  var attempt = null, busy = false, requestInFlight = false, confirmed = false, lastFocus = null, widget = null;
  var previousOverflow = '', validationTimeout = null;
  function message(value) { status.textContent = value; }
  function channel() { var node = form.querySelector('[name="channel"]:checked'); return node ? node.value : ''; }
  function fields() {
    var mode = channel();
    var email = form.elements.email, phone = form.elements.phone;
    email.closest('[data-contact]').hidden = mode !== 'email' && mode !== 'both';
    phone.closest('[data-contact]').hidden = mode !== 'whatsapp' && mode !== 'both';
    email.disabled = mode !== 'email' && mode !== 'both'; email.required = !email.disabled;
    phone.disabled = mode !== 'whatsapp' && mode !== 'both'; phone.required = !phone.disabled;
  }
  function resetChallenge() {
    if (window.turnstile && widget !== null) window.turnstile.reset(widget);
  }
  function renderChallenge() {
    if (!window.turnstile || widget !== null) return;
    widget = window.turnstile.render(challenge, {
      sitekey: root.dataset.sitekey, action: 'stock_notice', execution: 'execute',
      appearance: 'interaction-only',
      callback: receiveToken,
      'error-callback': function () { fail('No pudimos validar el aviso. Tus datos siguen aquí; vuelve a intentarlo.'); },
      'expired-callback': function () { if (busy) fail('La validación venció. Tus datos siguen aquí; vuelve a intentarlo.'); }
    });
    submit.disabled = false;
  }
  function fail(text) { clearTimeout(validationTimeout); busy = false; form.querySelector('[data-notice-fields]').disabled = false; submit.disabled = false; form.removeAttribute('aria-busy'); message(text); resetChallenge(); }
  function payload() {
    var mode = channel();
    var value = { productId: root.dataset.productId, topSize: form.elements.topSize.value,
      bottomSize: form.elements.bottomSize.value, channel: mode, noticeVersion: 'restock-v1' };
    if (mode === 'email' || mode === 'both') value.email = form.elements.email.value.trim();
    if (mode === 'whatsapp' || mode === 'both') value.phone = form.elements.phone.value.trim().replace(/[\s()-]/g, '');
    return value;
  }
  async function receiveToken(token) {
    if (!busy || requestInFlight || !attempt || !token) return;
    requestInFlight = true;
    clearTimeout(validationTimeout);
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 20000);
    try {
      var response = await fetch('/apps/banba-stock', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin', redirect: 'error', signal: controller.signal,
        body: JSON.stringify(Object.assign({}, attempt.value, { sourceId: attempt.id, turnstileToken: token })) });
      var result = await response.json();
      if (!response.ok || !result || result.ok !== true) {
        if (result && result.code === 'already_available') fail('Esta combinación está disponible. Cierra el aviso y vuelve a la ficha para comprobarla.');
        else fail('No pudimos confirmar el registro. Tus datos siguen aquí; vuelve a intentarlo.');
        return;
      }
      confirmed = true; busy = false; form.removeAttribute('aria-busy');
      form.querySelector('[data-notice-fields]').hidden = true;
      newNotice.hidden = false;
      message('Listo, tu aviso quedó registrado. No es una reserva ni una confirmación de disponibilidad.');
      form.elements.email.value = ''; form.elements.phone.value = ''; attempt = null;
      if (window.banbaClarityEvent) window.banbaClarityEvent('banba_stock_notice_confirmed');
    } catch (_) { fail('No pudimos confirmar el registro. Tus datos siguen aquí; vuelve a intentarlo.'); }
    finally { clearTimeout(timeout); requestInFlight = false; }
  }
  function open(top, bottom) {
    if (top && !busy) form.elements.topSize.value = top;
    if (bottom && !busy) form.elements.bottomSize.value = bottom;
    if (!root.classList.contains('on')) { lastFocus = document.activeElement; previousOverflow = document.documentElement.style.overflow; }
    root.classList.add('on'); root.removeAttribute('aria-hidden'); document.documentElement.style.overflow = 'hidden';
    root.querySelector('[data-notice-close]').focus();
    if (window.banbaClarityEvent) window.banbaClarityEvent('banba_stock_notice_opened');
    if (!confirmed && root.dataset.sitekey) {
      if (window.turnstile) renderChallenge();
      else if (!document.getElementById('banbaNoticeTurnstile')) {
        var script = document.createElement('script'); script.id = 'banbaNoticeTurnstile';
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; script.async = true;
        script.onload = renderChallenge; script.onerror = function () { message('La validación no está disponible. No se ha registrado el aviso; inténtalo más tarde.'); };
        document.head.appendChild(script);
      }
    }
  }
  function close() {
    root.classList.remove('on'); root.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = previousOverflow;
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  form.addEventListener('change', function () { fields(); });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (busy || confirmed) return;
    if (!channel() || !form.reportValidity()) { message('Elige ambas tallas, un canal y el contacto necesario.'); return; }
    if (!root.dataset.sitekey || !window.turnstile || widget === null || !window.crypto || !window.crypto.randomUUID) {
      message('El registro no está disponible. Tus datos siguen aquí; inténtalo más tarde.'); return;
    }
    var value = payload();
    if (value.phone && !/^\+[1-9]\d{7,14}$/.test(value.phone)) { message('Revisa el número con código de país, por ejemplo +56 y tu número móvil.'); return; }
    var fingerprint = JSON.stringify(value);
    if (!attempt || attempt.fingerprint !== fingerprint) attempt = { id: window.crypto.randomUUID(), fingerprint: fingerprint, value: value };
    busy = true; form.querySelector('[data-notice-fields]').disabled = true; submit.disabled = true; form.setAttribute('aria-busy', 'true'); message('Validando y registrando tu aviso…');
    validationTimeout = setTimeout(function () { if (busy) fail('La validación no respondió. Tus datos siguen aquí; vuelve a intentarlo.'); }, 60000);
    try { window.turnstile.reset(widget); window.turnstile.execute(challenge); }
    catch (_) { fail('No pudimos validar el aviso. Tus datos siguen aquí; vuelve a intentarlo.'); }
  });
  root.querySelector('[data-notice-close]').addEventListener('click', close);
  newNotice.addEventListener('click', function () {
    if (busy || requestInFlight) return;
    confirmed = false; attempt = null; form.reset(); fields();
    form.querySelector('[data-notice-fields]').hidden = false;
    form.querySelector('[data-notice-fields]').disabled = false;
    newNotice.hidden = true; submit.disabled = widget === null;
    resetChallenge(); message('Elige la nueva combinación y el canal de aviso.'); form.elements.topSize.focus();
  });
  root.addEventListener('click', function (event) { if (event.target === root) close(); });
  document.addEventListener('keydown', function (event) {
    if (!root.classList.contains('on')) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      var items = Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),a[href]')).filter(function (node) { return node.offsetParent !== null; });
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.body.appendChild(root); fields();
  window.banbaAvisoStock = { abrir: open };
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-aviso-open],a[href$="#avisame"]');
    if (trigger) { event.preventDefault(); open(trigger.dataset.avTop, trigger.dataset.avBottom); }
  });
  if (window.location.hash === '#avisame') open();
})();
